import { useEffect, useState } from "react";

export function useScrollShadows(
  overflowRef: React.RefObject<HTMLElement>,
  tab: number
) {
  const [shadow, setShadow] = useState({ left: false, right: false });

  useEffect(() => {
    const el = overflowRef.current;
    if (!el) return;

    const EPS = 2; // tolerance in pixels for floating errors

    const checkScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = el;

      const atStart = scrollLeft <= EPS;
      const atEnd = scrollWidth - clientWidth - scrollLeft <= EPS;

      setShadow({
        left: !atStart,
        right: !atEnd,
      });
    };

    // Initialize
    checkScroll();

    // Add listeners
    el.addEventListener("scroll", checkScroll, { passive: true });
    window.addEventListener("resize", checkScroll);

    // observe size changes dynamically
    const resizeObserver = new ResizeObserver(checkScroll);
    resizeObserver.observe(el);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
      resizeObserver.disconnect();
    };
  }, [overflowRef, tab]);

  return shadow; // { left: boolean, right: boolean }
}
